export default "__VITE_ASSET__BhLd7f4V__"